define('TescoMobile_Customer/js/view/account/dashboard/usage',['uiComponent', 'ko', 'mage/storage', 'mage/url'], function (Component, ko, storage, urlBuilder) {
  "use strict";

  return Component.extend({
    defaults: {
      template: 'TescoMobile_Customer/account/dashboard/usage'
    },
    usage: ko.observable({}),
    initialize: function () {
      const self = this;
      this._super();
      let serviceUrl = urlBuilder.build('/rest/V1/dashboard/usage-details', {});
      return storage.get(serviceUrl).done(function (response) {
        self.usage(response);
      });
    },
    getRenewDate: function () {
      let date = new Date(),
        numOfDays = Number(this.usage().renewal_period.substring(0, this.usage().renewal_period.indexOf(' ')));
      date.setDate(date.getDate() + numOfDays);
      let month = date.toLocaleString('en-GB', {
          month: 'short'
        }),
        day = date.getDate(),
        finalDate = ['on', day, month].join(' ');
      return finalDate;
    }
  });
});

